// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.analytics.properties.RentalManagerUserAnalyticsPropertiesWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CustomerAnalyticsListingPerformanceDailyBreakdownDtoV2,
  CustomerAnalyticsListingPerformanceDtoV2,
  ListingAlias,
} from '../..';

interface GetListingPerformanceDailyBreakdownV2Params {
  endDayYyyyMmDd: string;
  includeFreeStats?: boolean;
  includeMarketInsights: boolean;
  listingAlias: ListingAlias;
  startDayYyyyMmDd: string;
}
interface GetListingPerformanceV2Params {
  endDayYyyyMmDd: string;
  includeFreeStats?: boolean;
  includeMarketInsights: boolean;
  listingAlias?: string;
  startDayYyyyMmDd: string;
}

export const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_Path =
  '/api/web/v1/users/analytics/properties/getListingPerformanceDailyBreakdownV2';

/**
 * Get listing performance daily breakdown for custom time range
 */
export const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2 = (
  getParams: GetListingPerformanceDailyBreakdownV2Params,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetListingPerformanceDailyBreakdownV2Params,
    never,
    CustomerAnalyticsListingPerformanceDailyBreakdownDtoV2
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_Path =
  '/api/web/v1/users/analytics/properties/getListingPerformanceV2';

/**
 * Get listing performance for custom time range
 */
export const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2 = (
  getParams: GetListingPerformanceV2Params,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetListingPerformanceV2Params, never, CustomerAnalyticsListingPerformanceDtoV2>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
